/*       */

import { gql } from '@apollo/client';

export const eventTypeCommonQuery = `
    id
    name
    metadata
    preScript {
        id
    }
    script {
        id
    }
    active
    noActionOnDuplicate
    bpmnSignal
    lookupAttribute
    entityType{
      id
      name
      uri
    }
    descriptorType {
        id
        name
        uri
    }
    descriptorLookupAttribute
    createdBy {
        id
        name
        username
    }
    createdDate
    modifiedBy {
        id
        name
        username
    }
    modifiedDate
    eventDataAttributes {
                id
                attribute
                label
                format
                eventType
                type
                state
                indexName
            }
`;

export const loadEventTypeDetailsQuery = gql`
    query loadEventTypeDetailsQuery($id: ID!) {
        result: eventType(id: $id) {
            ${eventTypeCommonQuery}
        }
    }
`;
export const eventDataAttributesQuery = gql`query eventDataAttributes($filterBy: [JSON], $orderBy: [JSON] ) {
  eventDataAttributes(filterBy: $filterBy, orderBy: $orderBy) {
    id
    attribute
    label
    format
    eventType
    type
    state
    indexName
  }
}
`

export const eventTypesListQuery = gql`
    query eventTypesListQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $countMax: Int, $excludeBy: [JSON]) {
        count: count(dataType: "eventType", filterBy: $filterBy, max: $countMax)
        records: eventTypes(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${eventTypeCommonQuery}
        }
    }
`;

export const eventTypesListShortQuery = gql`
    query eventTypesListShortQuery($filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        records: eventTypes(filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
        }
    }
`;

export const allEventTypesQuery = gql`
    query allEventTypesQuery {
        records: eventTypes {
            id
            name
            eventDataAttributes {
                id
                attribute
                label
                format
                eventType
                type
                state
                indexName
            }
        }
    }
`;